import React from 'react';

// Banner discreto para el caso raro en que se detecta una versión nueva
// mientras el usuario sigue usando la app activamente (ver useVersionCheck).
export default function AvisoActualizacion({ onRecargar }) {
  return (
    <div style={estilos.contenedor}>
      <span>🔄 Hay una nueva versión disponible.</span>
      <button style={estilos.boton} onClick={onRecargar}>
        Actualizar ahora
      </button>
    </div>
  );
}

const estilos = {
  contenedor: {
    position: 'fixed',
    bottom: 16,
    right: 16,
    zIndex: 9999,
    background: '#1f2937',
    color: '#fff',
    padding: '10px 16px',
    borderRadius: 8,
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    fontSize: 14,
    boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
  },
  boton: {
    background: '#f97316',
    color: '#fff',
    border: 'none',
    borderRadius: 6,
    padding: '6px 12px',
    fontWeight: 600,
    cursor: 'pointer',
  },
};
